// デプロイ資材では debug/log/info/warn/errorを抑制する集中ロガー。
// 将来 Sentry 等の集約サービスへの送信を組み込む場合はここに集約する。
const isProd = process.env.NODE_ENV === "production"; // localhost起動時はログ出力を行い、build資材の場合はログ出力を抑制する

/* eslint-disable no-console */
export const logger = {
  debug: (...args) => {
    if (!isProd) console.debug(...args);
  },
  log: (...args) => {
    if (!isProd) console.log(...args);
  },
  info: (...args) => {
    if (!isProd) console.info(...args);
  },
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  error: (...args) => {
    if (!isProd) console.error(...args);
  },
};
/* eslint-enable no-console */
